import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function PaymentCancel() {
    return (
        <div className="min-h-screen bg-[#070A13] text-[#FDFBF7] grain flex flex-col">
            <div className="max-w-3xl mx-auto w-full px-6 py-10">
                <Link to="/" className="flex items-center gap-3">
                    <Logo className="w-9 h-9" dark />
                    <span className="font-display text-xl">The Raw Math</span>
                </Link>
            </div>
            <div
                data-testid="payment-cancel"
                className="flex-1 flex flex-col items-center justify-center text-center px-6 pb-24"
            >
                <XCircle size={40} className="text-white/40 mb-6" />
                <h1 className="font-display text-4xl tracking-tighter mb-4">
                    No worries — nothing was charged.
                </h1>
                <p className="font-body text-white/60 max-w-md mb-8">
                    Your dream is still waiting. Whenever you&apos;re ready, pick
                    your package and let&apos;s run your real numbers.
                </p>
                <Link
                    to="/#pricing"
                    data-testid="cancel-back-pricing"
                    className="inline-flex items-center gap-2 bg-[#C5A059] text-[#070A13] font-body font-semibold rounded-full px-8 py-4 transition-transform duration-300 hover:-translate-y-1"
                >
                    Choose my package
                </Link>
            </div>
        </div>
    );
}
